import { Stack, StackProps } from 'component-library';
import { Children, FC } from 'react';

import { FormField } from '@/components/Form';
import { TextAtomProps, TextContainer } from '@/components/widgets/a/Text/Text';
import { useToggle } from '@/hooks/useToggle';

import { ButtonWidget } from '../../a/Button/Button';
import { useControlsContext } from './Form';

type FilterSectionProps = {
  label?: TextAtomProps;
  section: StackProps;
  formName: string;
  previewChildrenLimit?: number;
} & StackProps;

export const FormSection: FC<FilterSectionProps> = ({
  formName,
  label,
  section,
  previewChildrenLimit,
  children,
  ...delegated
}) => {
  const [isCollapsed, setIsCollapsed] = useToggle(true);

  const controlsForm = useControlsContext();

  if (!children) {
    return null;
  }

  const limitChildren = previewChildrenLimit && Children.count(children) > previewChildrenLimit;
  const childrenToRender =
    limitChildren && isCollapsed
      ? Children.toArray(children).slice(0, previewChildrenLimit)
      : Children.toArray(children);

  const showChildrenLabel = isCollapsed ? 'global.analysis.seeMore' : 'global.analysis.seeLess';

  return (
    <Stack {...delegated}>
      <TextContainer {...label} />
      <FormField
        name={formName}
        control={controlsForm.control}
        render={() => (
          <>
            <Stack {...section}>{childrenToRender}</Stack>
            {limitChildren && (
              <ButtonWidget variant='text' onClick={setIsCollapsed} className='w-fit' size='small'>
                <TextContainer i18nPath={showChildrenLabel} />
                <i className={`ri-arrow-${isCollapsed ? 'down' : 'up'}-s-line ml-2`} />
              </ButtonWidget>
            )}
          </>
        )}
      ></FormField>
    </Stack>
  );
};
